import './AdvisorSection.css';

function ArrowIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <line x1="5"  y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  );
}

const pillars = [
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    title: 'Zero Risk. Zero Loss.',
    desc: 'Your retirement savings are placed in structures that are completely shielded from market downturns. When the market crashes, your balance does not.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 1 0 7H6" />
      </svg>
    ),
    title: 'Keep What You Earn.',
    desc: 'The IRS takes enough. Through Roth conversions, MSO structures, and tax-free income strategies, we legally eliminate the tax burden most people never question.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    title: 'Your Legacy, Protected.',
    desc: 'Wills, trusts, health directives, and life insurance — structured so your wealth transfers to the people you love without probate, taxes, or delay.',
  },
];

function AdvisorSection({ onOpenModal }) {
  return (
    <section className="advisor-section" id="advisor">
      <div className="advisor-glow" />

      <div className="adv-minimal">
        <span className="sec-pre rv">Why Work With Us</span>
        <h2 className="adv-h rv">
          Most advisors manage your money.<br />
          <em>We protect, multiply, and preserve it.</em>
        </h2>
        <div className="adv-pillars rv">
          {pillars.map((p, i) => (
            <div key={i} className="adv-pillar">
              <div className="adv-pillar-icon">{p.icon}</div>
              <h4>{p.title}</h4>
              <p>{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="adv-cta rv">
          <a
            href="#"
            className="btn-g"
            onClick={(e) => { e.preventDefault(); onOpenModal(); }}
          >
            Book a Free Strategy Call <ArrowIcon />
          </a>
          <span className="adv-cta-note">No obligation · Confidential · 30 minutes</span>
        </div>
      </div>
    </section>
  );
}

export default AdvisorSection;
